import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import * as moment from 'moment-timezone'
import * as React from 'react'

import t from './strings'

import WhatToBringManager from './whattobringmanager'
import WhatToExpectManager from './whattoexpectmanager'
import VerifyIdentity from './verifyidentity'

type ScheduleOrientationDetailsProps = {
  orientation: {
    startTime: string
    address: string
  }
  country: string
  uniqueLink: string
  timezone: string
  clearOrientation: any
  application?: any
  dasherId?: string
}
const formatAppointmentTime = (appointmentTime, timezone) =>
  moment(appointmentTime)
    .tz(timezone)
    .format('MMM Do [at] h:mm A')

const ScheduleOrientationDetails: React.SFC<ScheduleOrientationDetailsProps> = props => (
  <StackChildren>
    <Text styles={Text.Styles.Bold24}>{t.h1()}</Text>
    <Text lineHeight={Text.LineHeights.Medium} weight={Text.Weights.Bold}>
      {formatAppointmentTime(props.orientation.startTime, props.timezone)}
    </Text>
    <Text lineHeight={Text.LineHeights.Medium}>
      {props.orientation.address}
    </Text>
    <Button
      type={Button.Types.Tertiary}
      onClick={() => props.clearOrientation(props.uniqueLink)}
    >
      {t.reschedule()}
    </Button>
    <br />
    <VerifyIdentity country={props.country} dasherId={props.dasherId} />
    <br />
    <WhatToExpectManager country={props.country} />
    <br />
    <WhatToBringManager
      country={props.country}
      vehicleType={
        (props.application && props.application.vehicleType) || 'default'
      }
    />
    <br />
  </StackChildren>
)

export default ScheduleOrientationDetails
